<template>
	<div class="preloader" v-show="!pageLast">
		<div class="loadingSpinner">
			<svg
			 viewBox="25 25 50 50"
			 class="circular"
			>
				<circle
				 cx="50"
				 cy="50"
				 r="20"
				 fill="none"
				 class="path"
				></circle>
			</svg>
		</div>
	</div>
</template>

<script>
import { scrollTop, scrollHeight, windowHeight } from "@/utils/viewport";
export default {
	props: ["callback", "success", "pageLast", "bottom"],
	data() {
		return {
			func: undefined
		};
	},
	mounted() {
		this.$el.style.opacity = 0;
		this.$el.style.bottom = this.bottom ? this.bottom : "0";
		this.listenerStart();
	},
	methods: {
		listenerStart() {
			if (!this.pageLast) {
				var _this = this,
					loadingNode = this.$el;
				document.addEventListener(
					"scroll",
					(function() {
						_this.func = function f() {
							var st = scrollTop(),
								sh = scrollHeight(),
								wh = windowHeight();
							if (_this.pageLast) {
								document.removeEventListener(
									"scroll",
									_this.func,
									false
								);
							}
							if (Math.floor(st + wh + 1 >= sh)) {
								document.removeEventListener(
									"scroll",
									_this.func,
									false
								);
								_this.dataReady = false;
								loadingNode.style.opacity = 1;

								_this.callback().then(data=>{
									loadingNode.style.opacity = 0;
									_this.success(data, _this.listenerStart);
								});
							}
						};
						return _this.func;
					})(),
					false
				);
			}
		}
	},
	destroyed() {
		document.removeEventListener("scroll", this.func, false);
	}
};
</script>

<style lang="scss" scoped>
@import "~@/scss/libs.scss";
.preloader {
	@include square(100%, 100);
	@include dis-flex(center, center);
	transition: opacity 300ms;
	.circular {
		@include square(60);
		animation: loading-rotate 2s linear infinite;
		.path {
			animation: loading-dash 1.5s ease-in-out infinite;
			stroke-dasharray: 90, 150;
			stroke-dashoffset: 0;
			stroke-width: 2;
			stroke: #409eff;
			stroke-linecap: round;
		}
	}
	.last{
		@include square(100%,60);
		line-height: px2rem(60);
		text-align: center;
		font-size: px2rem(30);
		color: #a3a3a3;
	}
}
@keyframes loading-rotate {
	100% {
		transform: rotate(360deg);
	}
}

@keyframes loading-dash {
	0% {
		stroke-dasharray: 1, 200;
		stroke-dashoffset: 0;
	}
	50% {
		stroke-dasharray: 90, 150;
		stroke-dashoffset: -40px;
	}
	100% {
		stroke-dasharray: 90, 150;
		stroke-dashoffset: -120px;
	}
}
</style>
